import React from 'react';

import { Dropdown } from '@components/index';

import { UNASSIGNED_ASSIGNEE } from '../constants/common';
import { LeadAssignee as LeadAssigneeType } from '../types/common';

interface LeadAssigneeProps {
  assignee: LeadAssigneeType;
  assigneeOptions: LeadAssigneeType[];
  handleAssigneeSelect: (assignee: {
    id: string;
    isUnassigned: boolean;
  }) => void;
}

const LeadAssignee: React.FC<LeadAssigneeProps> = ({
  assignee,
  assigneeOptions,
  handleAssigneeSelect
}) => {
  const handleUpdateAssignee = (assigneeId: string) => {
    handleAssigneeSelect({
      id: assigneeId,
      isUnassigned: assigneeId === UNASSIGNED_ASSIGNEE.id
    });
  };

  const currentFilter = assignee.id ? assignee.id : UNASSIGNED_ASSIGNEE.id;

  return (
    <Dropdown
      currentFilter={currentFilter}
      filterOptions={assigneeOptions.map((option) => ({
        id: option.id || '',
        value: option.id || '',
        label: option.name
      }))}
      onSelectFilter={handleUpdateAssignee}
      placeholder="Select Assignee"
      className="!h-fit w-full !rounded-full !border-grey30 !py-1.5 focus:!border-[#BCBCBC] focus:!bg-[#FAFAFA]"
      optionsStyle="w-full max-h-56 overflow-y-auto"
      searchBarPlaceholder="Search Assignee"
      labelStyle="!text-base !font-normal !text-[#000000DE] max-width-166 truncate"
      stopEventPropagation
    />
  );
};

export default LeadAssignee;
